import React, { Component } from 'react';
import SProgramStudents from './SProgramStudents';
import { Tab } from 'semantic-ui-react';

class GradAgainStudents extends Component {
    render() {
        return (
            <div>
                <SProgramStudents
                    user={this.props.user}
                    studyTypes={this.props.studyTypes}
                    gradAgain
                />
            </div>
        );
    }
}

export default GradAgainStudents;



// WEBPACK FOOTER //
// ./src/views/StudentService/FilterStudents/GradAgainStudents.js